/* ICExtract sticky add-to-cart. Appears when the main buy form leaves the viewport.
   Mirrors selected variant / price, adds via the main product form's AJAX handler. */
(function () {
  'use strict';

  var bar = document.querySelector('[data-ic-sticky-atc]');
  if (!bar) return;

  var watchSel = bar.getAttribute('data-watch') || '[data-ic-buy]';
  var target = document.querySelector(watchSel);
  var priceEl = bar.querySelector('[data-ic-sticky-price]');
  var variantEl = bar.querySelector('[data-ic-sticky-variant]');
  var addBtn = bar.querySelector('[data-ic-sticky-add]');
  var qtyInput = bar.querySelector('[data-ic-sticky-qty]');

  var money = function (cents) {
    if (window.Shopify && window.Shopify.formatMoney && window.icMoneyFormat) {
      return window.Shopify.formatMoney(cents, window.icMoneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  };

  /* Show/hide via IntersectionObserver on the main buy area. */
  if (target && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });
    }, { threshold: 0 });
    io.observe(target);
  } else if (target) {
    window.addEventListener('scroll', function () {
      var rect = target.getBoundingClientRect();
      var visible = rect.bottom < 0;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }, { passive: true });
  }

  /* Mirror variant changes from the main picker. */
  document.addEventListener('ic:variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    if (priceEl) priceEl.textContent = money(v.price);
    if (variantEl && v.options) variantEl.textContent = v.options.join(' / ');
    if (addBtn) addBtn.disabled = !v.available;
  });

  /* Quantity buttons within the sticky bar. */
  var wrap = bar.querySelector('[data-ic-quantity]');
  if (wrap && qtyInput) {
    var down = wrap.querySelector('[data-ic-qty-down]');
    var up = wrap.querySelector('[data-ic-qty-up]');
    if (down) down.addEventListener('click', function () { var v = parseInt(qtyInput.value, 10) || 1; if (v > 1) qtyInput.value = v - 1; });
    if (up) up.addEventListener('click', function () { var v = parseInt(qtyInput.value, 10) || 1; qtyInput.value = v + 1; });
  }

  /* Add to cart: delegate to the main product form so the same variant/qty logic applies. */
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var form = document.querySelector('.ic-buy__form');
      if (!form) return;
      // Sync quantity into the main form before submitting.
      if (qtyInput) {
        var mainQty = form.querySelector('[data-ic-qty-input]');
        if (mainQty) mainQty.value = qtyInput.value;
      }
      var feedback = document.querySelector('[data-ic-buy-feedback]');
      if (typeof window.icAddToCart === 'function') {
        window.icAddToCart(form, addBtn, feedback);
      } else {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      }
    });
  }
})();
